import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IPost} from '../data.service';

@Component({
    selector: 'app-publication-item',
    templateUrl: './publication-item.component.html',
    styleUrls: ['./publication-item.component.scss']
})
export class PublicationItemComponent implements OnInit, OnChanges {

    data: IPost;
    @Input() itemData: IPost;
    @Input() moreLabel: string;
    @Input() showDescription = false;
    @Input() square = false;

    constructor() {
        this.data = {
            src: '',
            alt: '',
            title: '',
            description: '',
            link: null,
            position: ''
        };
    }

    ngOnInit(): void {
        this.data = {...this.itemData};
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.itemData && changes.itemData.currentValue && !changes.itemData.isFirstChange()) {
            this.data = {...changes.itemData.currentValue};
        }
    }
}
